import Post, {IPost} from '@/models/Post'

export interface IStaffBlog extends IPost {
}

export default class StaffBlog extends Post {
  constructor(defaults?: IStaffBlog) {
    super(defaults)
  }

  get className(): string {
    return StaffBlog.name
  }
}
